var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDropDownBlueIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Drop_down_icon",
    "data-name": "Drop down icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_249",
    "data-name": "Ellipse 249",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    fill: "#e0e7fe"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "caret-up",
    d: "M97.273,151.069l-2.213,2.583a.38.38,0,0,1-.577,0l-2.213-2.583a.38.38,0,0,1,.288-.627h4.427A.38.38,0,0,1,97.273,151.069Z",
    transform: "translate(-90.231 -147.473)",
    fill: "#9fb2f2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropDownBlueIcon);
export default __webpack_public_path__ + "static/media/drop-down-blue-icon.17d5fe0d286529963fbc7f97af7c7435.svg";
export { ForwardRef as ReactComponent };